


























import Component from 'vue-class-component'
import Vue from 'vue'
import UnifyList from '@/shared/components/unify/unify-list.vue'
import UnifyListItem from '@/shared/components/unify/unify-list-item.vue'
import UnifyListItemLabel from '@/shared/components/unify/unify-list-item-label.vue'
import UnifyListItemContent from '@/shared/components/unify/unify-list-item-content.vue'
import UnifyFormToggle from '@/shared/components/unify/unify-form-toggle.vue'
import UnifyButton from '@/shared/components/unify/unify-button.vue'
import { DialogService } from '@/shared/dialog/dialog-service'
import { Injector } from '@/config/dependency-injection'
import { OffersModule } from '@/business/offers/store/offers-module'
import { NotificationService } from '@/shared/services/notification-service'
import { VueRouter } from 'vue-router/types/router'
import { RouterToken } from '@/config/injection-tokens'
import { Prop } from 'vue-property-decorator'
import { OfferResponse } from '@/api/generated'
import { REMOVE_OFFER } from '@/business/offers/store/types'
import { LoaderHelper } from '@/shared/services/loader-helper'

@Component({
  name: 'offer-settings-settings',
  components: {
    UnifyButton,
    UnifyFormToggle,
    UnifyListItemContent,
    UnifyListItemLabel,
    UnifyListItem,
    UnifyList,
  },
})
export default class OfferSettingsSettings extends Vue {
  @Prop({
    required: true,
    type: Boolean,
  })
  public readonly loading!: boolean

  @Prop({
    required: true,
    type: Object,
  })
  public readonly offer!: OfferResponse

  private dialogService = Injector.get(DialogService)
  private loaderHelper = Injector.get(LoaderHelper)
  private notificationService = Injector.get(NotificationService)
  private offersModule = Injector.get(OffersModule)
  private router = Injector.get<VueRouter>(RouterToken)

  get removing() {
    return this.loaderHelper.isLoading(REMOVE_OFFER)
  }

  public confirmDelete() {
    this.dialogService.confirm('offer.delete.confirmation').then(ok => {
      if (ok) {
        this.offersModule.removeOffer(this.offer.id).then(() => {
          this.notificationService.success('common.successfulDelete')

          this.router.push({
            name: 'organisation-offers',
            params: {
              id: String(this.offer.organisation.id),
            },
          })
        })
      }
    })
  }
}
